"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("@powerednow/complexData/entity");
const date_1 = require("@powerednow/shared/modules/utilities/date");
let DocumentLogoEntity = class DocumentLogoEntity extends entity_1.EntityWithCompanyId {
};
__decorate([
    (0, entity_1.field)({
        type: 'int',
        primaryKey: true,
        hooks: {
            afterCreate: [{
                    handler: 'tagHubspot',
                    args: ['added_logo'],
                }],
        },
    })
], DocumentLogoEntity.prototype, "id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', primaryKey: true, serverOnly: true })
], DocumentLogoEntity.prototype, "company_id", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string', dbType: 'date', defaultValue: date_1.getNow })
], DocumentLogoEntity.prototype, "dt_created", void 0);
__decorate([
    (0, entity_1.field)({ type: 'string' })
], DocumentLogoEntity.prototype, "url", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentLogoEntity.prototype, "top", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentLogoEntity.prototype, "left", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentLogoEntity.prototype, "height", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentLogoEntity.prototype, "width", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int', allowNull: true })
], DocumentLogoEntity.prototype, "type", void 0);
__decorate([
    (0, entity_1.field)({ type: 'int' })
], DocumentLogoEntity.prototype, "source", void 0);
__decorate([
    (0, entity_1.field)({ defaultValue: 'not_uploaded', type: 'string' })
], DocumentLogoEntity.prototype, "status", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'boolean', codeName: 'isDeleted', serverOnly: true, defaultValue: false,
    })
], DocumentLogoEntity.prototype, "isdeleted", void 0);
__decorate([
    (0, entity_1.field)({
        type: 'string', dbType: 'date', serverOnly: true, defaultValue: null, allowNull: true,
    })
], DocumentLogoEntity.prototype, "dt_deleted", void 0);
__decorate([
    (0, entity_1.field)({ minAppVersion: '7.5.0', type: 'string' })
], DocumentLogoEntity.prototype, "document_type", void 0);
__decorate([
    (0, entity_1.field)({ minAppVersion: '9.0.0', type: 'boolean' })
], DocumentLogoEntity.prototype, "isCompanyLogo", void 0);
DocumentLogoEntity = __decorate([
    entity_1.EntityDecorator
], DocumentLogoEntity);
exports.default = DocumentLogoEntity;
//# sourceMappingURL=../../../../src/models/documentLogo/entity.js.map